import { html, TemplateResult } from 'lit';
import { ErrorIcon } from './status-icons';
import { ErrorType } from '../../../interfaces/index.js';

export const renderError = (errorType: ErrorType, orderCode: string) => {
  let title = '';
  let message: TemplateResult;

  switch (errorType) {
    case 'no-code':
      title = 'Kein Code angegeben';
      message = html`
        <p>
          Um deinen Auftrag anzuzeigen, benötigst du einen gültigen Code.
          <br />
          Bitte überprüfe die URL oder den Link, den du erhalten hast. Der Link
          sollte im Format auf etwas wie <em>?code=ABC-123</em> enden.
        </p>
      `;
      break;
    case 'not-found':
      title = 'Auftrag nicht gefunden';
      message = html`
        <p>
          Zum Code: <strong>${orderCode}</strong> konnte kein Auftrag gefunden
          werden. Der Code sollte im Format <em>ABC-123</em> also aus Ziffern
          und Buchstaben getrennt durch einen Bindestrich bestehen.
        </p>
      `;
      break;
    case 'network':
    default:
      title = 'Fehler beim Laden';
      message = html`
        <p>
          Der Auftrag konnte nicht geladen werden. Bitte überprüfe deine
          Internetverbindung und versuche es erneut.
        </p>
      `;
      break;
  }

  return html`
    <div id="order-status">
      <div id="icon">${ErrorIcon}</div>
      <div id="meta">
        <h2>${title}</h2>
      </div>
    </div>

    <div id="divider"></div>
    <div id="order-content">${message}</div>
  `;
};
